<template>
  <div class="charttest">
    <div   style="width:100%;
       height: 294px;" :id="echarts" ref="echarts">
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import { mapActions } from "vuex";
  import {EleResize} from '@/assets/js/mapFormat.js'
  export default {
    name:'LineChart',
    data() {
      return {
      dataAxis: [],
      myChart1: "",
      // itemIndusty: {
      //   // apply: [],
      //   // total: [],
      // },
      itemIndusty:[],
      chartcomYear:[],
      chartcomNumAcc:[],
      chartcomNum:[],
      };
    },
      created() {
        this.initChartsChart()
      },
       mounted() {
    //   this.drawCharts();
      this.$nextTick(() => {
      setTimeout(() => {
        this.drawCharts();
      
      },1000);
    });
    },
    methods: {
         ...mapActions("category", [
        "getChartData",
    ]),    
    //共用一个组件的接口
    initChartsChart() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "pa_vipcoms_trend",
          //园区专利申请/授权趋势
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
      console.log(res.message,"=====res.message====")
          _this.chartsdata = res.message.data;
          _this.itemIndusty=res.message.data[0].items;
           _this.itemIndustyAcc=res.message.data[0].itemsAcc;
           let comYear=[]
           let  comNum=[]
             _this.itemIndusty.forEach((item) => {
            let year = item.year;
            let num = item.num;
            comNum = comNum.concat(num);
            comYear = comYear.concat(year);
          });
          _this.chartcomYear= comYear;
          _this.chartcomNum=comNum

          //折线图
           let  comNumAcc=[]
             _this.itemIndustyAcc.forEach((item) => {
            let num = item.num;
            comNumAcc = comNumAcc.concat(num);
          });
          _this.chartcomNumAcc=comNumAcc
         console.log(_this.chartcomNumAcc,"==_this.chartcomNumAcc====")
        },
      });
    },
 initChart() {
        this.myChart = echarts.init(document.getElementById(this.echarts));

      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
      drawCharts() {
        var myChart = echarts.init(document.getElementById(this.echarts));
        myChart.setOption({
      
 tooltip: {
    axisPointer: {
      type: 'cross',
      crossStyle: {
      }
    }
  },
  toolbox: {
    feature: {
    }
  },
  legend: {
    data: ['当年专利总量', '累计专利总量']
  },

  xAxis: [
    {
      type: 'category',
         splitLine:{ 
            show:false 
               },
       name:"",
     data:this.chartcomYear,
    axisLabel: {
            color: "#777C8B",
          },
          axisTick: {
            lineStyle: {
               color:"#0095FF"
            },
          },
      axisPointer: {
        type: 'shadow'
      }
    }
  ],
  yAxis: [
    {
      type: 'value',
         splitLine:{ 
            show:false 
               },
       axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "#C2C2C2", //深灰
              width: 1,
            },
          },
      name: '',
    
     
    },
    {
     
    }
  ],
  series: [
  
    {
       barWidth : 10,
      name: '当年专利总量',
      type: 'bar',
      itemStyle:{
       normal:{
           color:'#0095FF'
       }
      },
      data:this.chartcomNum
    },
    {
      name: '累计专利总量',
      type: 'line',
      yAxisIndex: 1,
       smooth: true,
         itemStyle:{
       normal:{
           color:'#33D1B1'
       }
      },
       data:this.chartcomNumAcc
    }
  ]

        });

      }
      

      
    },
    computed: {
      echarts() {
        return 'echarts' + Math.random() * 100000;
      }
    },
   
    destroyed() {
      window.removeEventListener("resize", this.initChart, 20);
  },
    components: {}
  };
</script>

<style>
#charttest {
  width: 100%;
  height: 600px;
}
</style>